module.exports = __webpack_public_path__ + "static/media/eteatr.ce4e10f4.png";